import React, { useState } from 'react';

import { OurTeamProps } from '@utils/aboutInterfaces';

import MessageModal from '../../../MessageModal';
import Group from './Group';

const OurTeam = ({ canSendMessage, team }: OurTeamProps) => {
  const [messageUser, setMessageUser] = useState(null);

  return (
    <article>
      <h2 className="my-0 border-0 border-b border-solid border-grayscale-beige pb-24 font-suisse-works text-headline-md">
        Our Team
      </h2>
      <div className="flex flex-col justify-start font-suisse-intl-mono text-caption-lg">
        {team.map((group) => (
          <Group
            group={group}
            setMessageUser={setMessageUser}
            canSendMessage={canSendMessage}
            key={group.name}
          />
        ))}
      </div>
      {canSendMessage && <MessageModal user={messageUser} onClose={() => setMessageUser(null)} />}
    </article>
  );
};

export default OurTeam;
